class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;
    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    //this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
    this.mainDetailsToggle.addEventListener("click", this.onClick.bind(this));
  }

  onFocusOut() {
    if (!this.mainDetailsToggle.classList.contains("disclosure")) {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  onClick(e) {
    if (!this.animations) this.animations = this.content.getAnimations();
    // close other details
    document.querySelectorAll("details").forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        details.removeAttribute("open");
        details.querySelector("summary").setAttribute("aria-expanded", false);
      }

      if (details?.id?.startsWith("Details-HeaderMenu")) {
        // get summary element with class header__submenu_container
        const summary = details.querySelector(
          "details.header__submenu_container"
        );

        if (summary) {
          summary.setAttribute("aria-expanded", true);
          summary.setAttribute("open", "");
        }
      }
    });

    const parent = e.target.offsetParent;
    const ariaControls = parent?.getAttribute("aria-controls");
    if (ariaControls && ariaControls.includes("HeaderMenu-MenuList")) {
      // get summary element with class header__submenu_container
      const summary = this.mainDetailsToggle.querySelector(
        "details.header__submenu_container"
      );
      if (summary) {
        summary.setAttribute("aria-expanded", true);
        summary.setAttribute("open", "");
      }
    }

    if (this.mainDetailsToggle.classList.contains("footer-menu")) {
      const icon = this.mainDetailsToggle.querySelector(
        "span.disclosure__toggle"
      );
      icon.style.transform = icon.style.transform ? "" : "scaleY(-1)";
    }

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  simulateFirstClick() {
    if (this.mainDetailsToggle?.id?.startsWith("Details-HeaderMenu")) {
      // get summary element with class header__submenu_container
      const summary = this.mainDetailsToggle.querySelector(
        "details.header__submenu_container"
      );
      console.log("simulateFirstClick", summary);

      summary.addEventListener("click", (e) => {
        console.log("clickeeed", e);
      });
      if (summary) {
        summary.click();
      }
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);
